import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'

export const SendDraftEnrolmentFields = () => (
  <fieldset>This will submit this draft enrolment to the government</fieldset>
)

export const SendDraftEnrolmentDone = ({ errors = [] }) =>
  errors.length > 0 ? (
    <fieldset>
      The draft enrolment was submitted, but there were some errors...
      <FormDisplayErrors errors={errors} />
    </fieldset>
  ) : (
    <fieldset>The draft enrolment was successfully submitted</fieldset>
  )



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/submit-draft-enrolment/fields.jsx